<template>
  <h1>Welcome to training course!</h1>
</template>

<script>
export default {
  name: "Main"
}
</script>

<style scoped>
</style>